import script from "./GoogleEventModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoogleEventModal.vue?vue&type=script&lang=ts&setup=true"

import "./GoogleEventModal.vue?vue&type=style&index=0&id=44da3d0c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44da3d0c"]])

export default __exports__